import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormControl, Validators} from '@angular/forms';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {ActivityFilterService} from '../../../services/activity-filter.service';
import {
  ActivityFeedType, ActivityFilterModel, ActivityFilterType, ActivityFilterTypes, ActivityFilterTypesEnumType,
  ActivityFilterTypesTilte,
  ActivityFilterViewModel,
  ActivitySelectionItem
} from '../../../store/activity.model';
import {PlatformCommand} from '@shared/commands/command-base';
import {SnackBarService} from "@core/services/snack-bar.service";
import {IPlatformToolHandler} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {BehaviorSubject, Subject} from "rxjs";
import {take, takeUntil} from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";
import {Router} from "@angular/router";
import {TaskMenuDetails} from "../../../../models/task-manager.model";
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";
import {TaskManagerService} from "../../../../services/task-manager.service";
import {CollaborationState} from "../../../store/collaboration.reducer";
import {select, Store} from "@ngrx/store";
import {getCurrentTypeOfSavedFilter} from "../../../store/collaboration.selector";
import {SetCurrentTypeOfSavedFilter} from "../../../store/collaboration.action";
import {ShareItemsComponent} from "@shared/components/share-items/share-items.component";
import {ChatPermissions} from "../../../store/collaboration.constants";
import {UserModel} from "@shared/models/user.model";
import {SecurityState} from "@shared/store/reducers/security.reducer";
import {ShareItemService} from "@shared/services/share-item.service";
import {getUserInfo} from "@shared/store/selectors/security.selector";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {IQueryState} from "@shared/store/reducers/query.reducer";

@Component({
    standalone: false,
    selector: 'particle-activity-tracker-filter',
  templateUrl: './activity-tracker-filter.component.html',
  styleUrls: ['./activity-tracker-filter.component.scss']
})
export class ActivityTrackerFilterComponent implements OnInit, OnDestroy {
  @Input() filterId: string;
  @Input() handler: IPlatformToolHandler;
  @Input() saveFilter$: BehaviorSubject<string> = new BehaviorSubject(null);
  @Output() cancelFilter$: EventEmitter<boolean> = new EventEmitter();
  @Output() applyFilter$: EventEmitter<any> = new EventEmitter();
  @Output() onAddNewFilter$: EventEmitter<boolean> = new EventEmitter(false);
  @Input() setFeedOnRightSidebar: boolean = true;
  selectedTabIndex: number = 0;
  activityFilterViewModel: ActivityFilterViewModel = null;
  activityTypes: ActivitySelectionItem[] = [];
  userRoleOptions: ActivitySelectionItem[] = [];
  selectedActivityTypes: any[] = [];
  selectedUsers: string[] = [];
  selectedProjects: string[] = [];
  selectedCountryCodes: string[] = [];
  selectedCases: string[] = [];
  selectedEntities: string[] = [];
  selectedTransactions: string[] = [];
  userDataOptions: ActivitySelectionItem[] = [];
  activityFilterForm: any;
  solutionsChecked: boolean = false;
  activityFilters: ActivityFilterModel[] = [];
  private selectedRoles: any[] = [];
  private selectedData: any[] = [];
  unSubscribe$ = new Subject<void>();
  activityFilterTypesEnumType: any = ActivityFilterTypesEnumType;
  activityFilterTypesTilte: any = ActivityFilterTypesTilte;
  activityFilterTypes: Array<ActivityFilterType> = ActivityFilterTypes;
  currentTypeOfSavedFilter: ActivityFilterType = null;
  currentUser: UserModel;
  allContactListqueryKey = 'AllContactList';
  totalUserCount: number = 0;
  isDrityFilter: boolean = false;

  constructor(private formBuilder: FormBuilder,
              private dialogService: DialogService,
              public dialog: MatDialog,
              public securityStore: Store<SecurityState>,
              private queryStore: Store<IQueryState>,
              protected shareItemService: ShareItemService,
              private commandService: CommandService,
              public collaborationStore: Store<CollaborationState>,
              private taskManagerService: TaskManagerService,
              private router: Router,
              private snackBarService: SnackBarService,
              private activityFilterService: ActivityFilterService) {
  }

  ngOnInit() {
    this.securityStore.pipe(select(getUserInfo)).pipe(takeUntil(this.unSubscribe$)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
    this.collaborationStore.select(getCurrentTypeOfSavedFilter).pipe(takeUntil(this.unSubscribe$)).subscribe(currentType => {
      this.currentTypeOfSavedFilter = currentType;
      if(this.currentTypeOfSavedFilter == null) {
        this.currentTypeOfSavedFilter = this.activityFilterTypes[0];
      }
    });
    this.setUpActivityFilterForm();
    this.setActivityFilterData();
    //we want edit filter tab to be default.
    /*    if(!this.setFeedOnRightSidebar || this.editFilterInProgress) {
          this.setActivityFilterData();
        } else {
          this.selectedTabIndex = 1;
          this.onChangeFiltersType(this.currentTypeOfSavedFilter);
        }*/
    this.saveFilter$.pipe(takeUntil(this.unSubscribe$)).subscribe(title => {
      if (title) {
        this.saveFilter(title);
      }
    });
    if (this.handler && this.handler.magicLinkModelValueChanged) {
      this.handler.magicLinkModelValueChanged.pipe(takeUntil(this.unSubscribe$)).subscribe(commamd => {
        this.handleMagicLinkValueChanged(commamd);
      });
    }
    this.queryStore.pipe(select(getQueryResponse, this.allContactListqueryKey), takeUntil(this.unSubscribe$)).subscribe(response => {
      if(response && response.contacts) {
        this.totalUserCount = response.contacts.length;
        //console.log('[total user count] ', this.totalUserCount);
      }
    });
  }

  closeActivityFeed($event) {

  }

  saveFilterOnRightSideBar($event) {
    this.activityFilterService.ChangeFilterTilteDialog(this.activityFilterViewModel.title).pipe(takeUntil(this.unSubscribe$)).subscribe((title: any) => {
      if(title) {
        this.saveFilter(title);
      }
    });
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private handleMagicLinkValueChanged(action: any) {
    //console.log(action, this.translationModel);
    /*    if (action) {
     switch (action.name) {

     }
     }*/
  }

  dispatchDataToHandler(event) {
    //{action: {id: 'SaveTranslationModel'}, item: translationModel}
    this.handler.valueChanged(event);
  }

  onCancel($event) {
    this.cancelFilter$.next(true);
  }

  onTypeCheckboxChange(index) {
    //console.log('[checked index]',index);
    let indexOfAll = this.activityFilterViewModel.activities.findIndex(activity => activity.key === 'All');
    let formArray= this.activityFilterForm.get('activityTypesArray') as FormArray;
    let isAllChecked = formArray.at(indexOfAll).value;
    if(isAllChecked && indexOfAll === index) {
      formArray.controls.forEach((control, idx) => {
        control.setValue(true);
        this.activityFilterViewModel.activities[idx].isChecked = true;
      });
    }
    else if(!isAllChecked && indexOfAll === index) {
      formArray.controls.forEach((control, idx) => {
        control.setValue(false);
        this.activityFilterViewModel.activities[idx].isChecked = false;
      });
    } else {
      let isCurrentItemChecked = formArray.at(index).value;
      if(isCurrentItemChecked) {
        this.activityFilterViewModel.activities[index].isChecked = true;
        if(this.isAllChecked(this.activityFilterViewModel.activities, false)) {
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.activities[indexOfAll].isChecked = true;
        }
      } else {
        formArray.at(indexOfAll).setValue(false);
        this.activityFilterViewModel.activities[index].isChecked = false;
        this.activityFilterViewModel.activities[indexOfAll].isChecked = false;
      }
    }
    this.onApply(false);
    //console.log('[All checked], ', formArray.at(indexOfAll));
  }

  onRoleCheckboxChange(index) {
    //console.log('[checked index]',index);
    let indexOfAll = this.activityFilterViewModel.users.findIndex(activity => activity.key === 'All');
    let formArray= this.activityFilterForm.get('usersRolesArray') as FormArray;
    let isAllChecked = formArray.at(indexOfAll).value;
    if(isAllChecked && indexOfAll === index) {
      formArray.controls.forEach((control, idx) => {
        control.setValue(true);
        let user = this.activityFilterViewModel.users[idx];
        user.isChecked = true;
        if(idx !== indexOfAll) {
          user.editor.allRecords = true;
          user.editor.displayText = `All ${user.key}`;
          user.editor.selectedValues = [];
        }
      });
    } else if(!isAllChecked && indexOfAll === index) {
      formArray.controls.forEach((control, idx) => {
        control.setValue(false);
        let user = this.activityFilterViewModel.users[idx];
        user.isChecked = false;
        if(idx !== indexOfAll) {
          user.editor.allRecords = false;
          user.editor.displayText = `Select ${user.key}`;
          user.editor.selectedValues = [];
        }
      });
    } else {
      let isCurrentItemChecked = formArray.at(index).value;
      if(isCurrentItemChecked) {
        let user = this.activityFilterViewModel.users[index];
        user.isChecked = true;
        if(index !== indexOfAll) {
          user.editor.allRecords = true;
          user.editor.displayText = `All ${user.key}`;
          user.editor.selectedValues = [];
        }
        if(this.isAllChecked(this.activityFilterViewModel.users, true)) {
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.users[indexOfAll].isChecked = true;
        }
      } else {
        formArray.at(indexOfAll).setValue(false);
        let user = this.activityFilterViewModel.users[index];
        user.isChecked = false;
        user.editor.allRecords = false;
        user.editor.displayText = `Select ${user.key}`;
        user.editor.selectedValues = [];
        this.activityFilterViewModel.users[indexOfAll].isChecked = false;
      }
    }
    this.onApply(false);
  }
  onTabIndexChange($event: any) {
    //console.log('tab change:', $event);
    this.selectedTabIndex = $event.index;
    if(this.selectedTabIndex === 0 && this.setFeedOnRightSidebar) {
      this.setActivityFilterData();
    } else {
      this.onChangeFiltersType(this.currentTypeOfSavedFilter);
    }
  }

  onOpenInMainView(filter) {
    //console.log('filter:', filter);
    this.router.navigateByUrl(`activities/filter/${filter.id}`);
  }

  onShareFilter(filter) {
    //console.log('filter:', filter);
    const task = filter.taskInfo;
    if (task && task.ticketId && task.boardScope) {
      const taskMenuDetails = new TaskMenuDetails();
      taskMenuDetails.id = 'TaskAssignee';
      this.taskManagerService.openTaskByTaskId(task.ticketId,
        GraphqlContentScope.getScope(GraphqlContentScope.getScope(task.boardScope)), null, null,
        taskMenuDetails, true);
    }
  }
  onDataCheckboxChange(index) {
    //console.log('[checked index]',index);
    let indexOfAll = this.activityFilterViewModel.data.findIndex(activity => activity.key === 'All');
    let formArray= this.activityFilterForm.get('userDataArray') as FormArray;
    let isAllChecked = formArray.at(indexOfAll).value;
    if(isAllChecked && indexOfAll === index) {
      formArray.controls.forEach((control, idx) => {
        control.setValue(true);
        let data = this.activityFilterViewModel.data[idx];
        data.isChecked = true;
        if(idx !== indexOfAll) {
          data.editor.allRecords = true;
          data.editor.displayText = `All ${data.key}`;
          data.editor.selectedValues = [];
        }
      });
    } else if(!isAllChecked && indexOfAll === index) {
      formArray.controls.forEach((control, idx) => {
        control.setValue(false);
        let data = this.activityFilterViewModel.data[idx];
        data.isChecked = false;
        if(idx !== indexOfAll) {
          data.editor.allRecords = false;
          data.editor.displayText = `Select ${data.key}`;
          data.editor.selectedValues = [];
        }
      });
    } else {
      let isCurrentItemChecked = formArray.at(index).value;
      if(isCurrentItemChecked) {
        let data = this.activityFilterViewModel.data[index];
        data.isChecked = true;
        if(index !== indexOfAll) {
          data.editor.allRecords = true;
          data.editor.displayText = `All ${data.key}`;
          data.editor.selectedValues = [];
        }
        if(this.isAllChecked(this.activityFilterViewModel.data)) {
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.data[indexOfAll].isChecked = true;
        }
      } else {
        formArray.at(indexOfAll).setValue(false);
        let data = this.activityFilterViewModel.data[index];
        data.isChecked = false;
        data.editor.allRecords = false;
        data.editor.displayText = `Select ${data.key}`;
        data.editor.selectedValues = [];
        this.activityFilterViewModel.data[indexOfAll].isChecked = false;
      }
    }
    this.onApply(false);
  }

  onSolutionsCheckboxChanged($event) {
    //console.log('solutions:', $event, this.activityFilterViewModel);
    if(this.activityFilterViewModel.tools.isChecked) {
      let toolEditor = this.activityFilterViewModel.tools.editor;
      toolEditor.allRecords = true;
      toolEditor.selectedValues = [];
      toolEditor.displayText = `All ${this.activityFilterViewModel.tools.key}`;
    } else {
      let toolEditor = this.activityFilterViewModel.tools.editor;
      toolEditor.allRecords = false;
      toolEditor.selectedValues = [];
      toolEditor.displayText = `Select ${this.activityFilterViewModel.tools.key}`;
    }
    this.onApply(false);
  }

  onUserDataOptionClick(data: ActivitySelectionItem, index?: number) {
    //console.log('on checked data:', data);
    switch (data.key) {
      case 'Projects':
        this.openProjectSelectorDialog(data.editor.editor, index);
        break;
      case 'Transactions':
        this.openTransactionsSelectorDialog(data.editor.editor, index);
        break;
      case 'Entities':
        this.openEntitiesSelectorDialog(data.editor.editor, index);
        break;
      case 'Cases':
        this.openCasesSelectorDialog(data.editor.editor, index);
        break;
      case 'Countries':
        this.openCountrySelectorDialog(data.editor.editor, index);
        break;

    }
  }

  onUserRoleOptionClick(data: ActivitySelectionItem,index) {
    //console.log('on checked data:', data);
    switch (data.key) {
      case 'Users':
        this.onUserSelector(data, index);
        break;
    }
  }

  onApply(dispatchFilter: boolean = true) {
    if (!this.isFilterValid()) {
      return;
    }
    let fieldValues: any = {};
    fieldValues['ActivityFilterViewModel'] = this.activityFilterViewModel;
    this.saveFilterToApi(fieldValues, dispatchFilter);
  }

  dispatchFilter(filter) {
    this.applyFilter$.next(filter);
  }

  onChangeFiltersType(filterType: ActivityFilterType) {
    //console.log('action Type: ',filterType);
    switch (filterType.type) {
      case ActivityFilterTypesEnumType.ManageFilter:
        this.onManageFilters();
        break;
      default:
        this.fetchActivityFiltersByType(filterType);
    }
  }

  onManageFilters() {
    this.router.navigateByUrl('activities');
  }
  private openProjectSelectorDialog(editor: string, index: number) {
    const dialogModel: DialogModel = DialogModel.create(
      'Project Selector',
      editor,
      {selectedProjectsId: this.activityFilterViewModel.data[index].editor.selectedValues, allRecords: this.activityFilterViewModel.data[index].editor.allRecords},
      '765px',
      '765px'
    );

    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        //console.log('[Project Selector] project selector', res.data.input.selectedProjectsId);
        this.selectedProjects = res.data.input.selectedProjectsId;
        let allItemsSelected = res.data.input.allItemsSelected;
        if(!allItemsSelected) {
          this.uncheckDataAllRecords();
        }
        let projectEditor = this.activityFilterViewModel.data[index];
        projectEditor.editor.selectedValues = this.selectedProjects;
        projectEditor.editor.allRecords = allItemsSelected;
        if(allItemsSelected) {
          projectEditor.editor.displayText = `All ${projectEditor.key}`;
        } else {
          projectEditor.editor.displayText = this.selectedProjects.length == 0 ? `Select ${projectEditor.key}` : `${this.selectedProjects.length} ${projectEditor.key}`;
        }
        if(this.isAllChecked(this.activityFilterViewModel.data)) {
          let indexOfAll = this.activityFilterViewModel.data.findIndex(activity => activity.key === 'All');
          let formArray= this.activityFilterForm.get('userDataArray') as FormArray;
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.data[indexOfAll].isChecked = true;
        }
        this.onApply(false);
      }
    });
  }

  private openTransactionsSelectorDialog(editor: string, index: number) {
    const dialogModel: DialogModel = DialogModel.create(
      'Transaction Selector',
      editor,
      {selectedItems: this.activityFilterViewModel.data[index].editor.selectedValues,allRecords: this.activityFilterViewModel.data[index].editor.allRecords},
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        this.selectedTransactions = res.data.input.selectedItems;
        //console.log('stream items:', this.selectedTransactions);
        let allItemsSelected = res.data.input.allItemsSelected;
        if(!allItemsSelected) {
          this.uncheckDataAllRecords();
        }
        let transactionEditor = this.activityFilterViewModel.data[index];
        transactionEditor.editor.selectedValues = this.selectedTransactions;
        transactionEditor.editor.allRecords = allItemsSelected;
        if(allItemsSelected) {
          transactionEditor.editor.displayText = `All ${transactionEditor.key}`;
        } else {
          transactionEditor.editor.displayText = this.selectedTransactions.length == 0 ? `Select ${transactionEditor.key}` : `${this.selectedTransactions.length} ${transactionEditor.key}`;
        }
        if(this.isAllChecked(this.activityFilterViewModel.data)) {
          let indexOfAll = this.activityFilterViewModel.data.findIndex(activity => activity.key === 'All');
          let formArray= this.activityFilterForm.get('userDataArray') as FormArray;
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.data[indexOfAll].isChecked = true;
        }
        this.onApply(false);
      }
    });
  }

  private openEntitiesSelectorDialog(editor: string, index: number) {
    const dialogModel: DialogModel = DialogModel.create(
      'Entity Selector',
      editor,
      {selectedItems: this.activityFilterViewModel.data[index].editor.selectedValues,allRecords: this.activityFilterViewModel.data[index].editor.allRecords},
      '765px',
      '765px'
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        //console.log('[Entity Selector] entity selector', res.data.input.selectedItems);
        this.selectedEntities = res.data.input.selectedItems;
        let allItemsSelected = res.data.input.allItemsSelected;
        if(!allItemsSelected) {
          this.uncheckDataAllRecords();
        }
        let entityEditor = this.activityFilterViewModel.data[index];
        entityEditor.editor.selectedValues = this.selectedEntities;
        entityEditor.editor.allRecords = allItemsSelected;
        if(allItemsSelected) {
          entityEditor.editor.displayText = `All ${entityEditor.key}`;
        } else {
          entityEditor.editor.displayText = this.selectedEntities.length == 0 ? `Select ${entityEditor.key}` : `${this.selectedEntities.length} ${entityEditor.key}`;
        }
        if(this.isAllChecked(this.activityFilterViewModel.data)) {
          let indexOfAll = this.activityFilterViewModel.data.findIndex(activity => activity.key === 'All');
          let formArray= this.activityFilterForm.get('userDataArray') as FormArray;
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.data[indexOfAll].isChecked = true;
        }
        this.onApply(false);
      }
    });
  }

  private openCasesSelectorDialog(editor: string, index: number) {
    const dialogModel: DialogModel = DialogModel.create(
      'Case Selector',
      editor,
      {selectedItems: this.activityFilterViewModel.data[index].editor.selectedValues,allRecords: this.activityFilterViewModel.data[index].editor.allRecords},
      '765px',
      '765px'
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        this.selectedCases = res.data.input.selectedItems;
        let allItemsSelected = res.data.input.allItemsSelected;
        if(!allItemsSelected) {
          this.uncheckDataAllRecords();
        }
        let caseEditor = this.activityFilterViewModel.data[index];
        caseEditor.editor.selectedValues = this.selectedCases;
        caseEditor.editor.allRecords = allItemsSelected;
        if(allItemsSelected) {
          caseEditor.editor.displayText = `All ${caseEditor.key}`;
        } else {
          caseEditor.editor.displayText = this.selectedCases.length == 0 ? `Select ${caseEditor.key}` : `${this.selectedCases.length} ${caseEditor.key}`;
        }
        if(this.isAllChecked(this.activityFilterViewModel.data)) {
          let indexOfAll = this.activityFilterViewModel.data.findIndex(activity => activity.key === 'All');
          let formArray= this.activityFilterForm.get('userDataArray') as FormArray;
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.data[indexOfAll].isChecked = true;
        }
        this.onApply(false);
      }
    });
  }

  private openCountrySelectorDialog(editor: string, index: number) {
    const dialogModel: DialogModel = DialogModel.create(
      'Countries',
      editor,
      {selectedCountryCodes: this.activityFilterViewModel.data[index].editor.selectedValues,allRecords: this.activityFilterViewModel.data[index].editor.allRecords},
      '560px',
      '560px'
    );

    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        this.selectedCountryCodes = res.data.input.selectedCountryCodes;
        let allItemsSelected = res.data.input.allItemsSelected;
        if(!allItemsSelected) {
          this.uncheckDataAllRecords();
        }
        //console.log('[selected country codes:]', this.selectedCountryCodes);
        let countryEditor = this.activityFilterViewModel.data[index];
        countryEditor.editor.selectedValues = this.selectedCountryCodes;
        countryEditor.editor.allRecords = allItemsSelected;
        if(allItemsSelected) {
          countryEditor.editor.displayText = `All ${countryEditor.key}`;
        } else {
          countryEditor.editor.displayText = this.selectedCountryCodes.length == 0 ? `Select ${countryEditor.key}` : `${this.selectedCountryCodes.length} ${countryEditor.key}`;
        }
        if(this.isAllChecked(this.activityFilterViewModel.data)) {
          let indexOfAll = this.activityFilterViewModel.data.findIndex(activity => activity.key === 'All');
          let formArray= this.activityFilterForm.get('userDataArray') as FormArray;
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.data[indexOfAll].isChecked = true;
        }
        this.onApply(false);
      }
    });
  }

  private setUpActivityFilterForm(filterModel?: any) {
    this.activityFilterForm = this.formBuilder.group({
      activityTypesArray: new FormArray([], Validators.required),
      usersRolesArray: new FormArray([], Validators.required),
      userDataArray: new FormArray([], Validators.required)
    });
  }

  private addFormControl(controlArrayName: string, formState?: boolean) {
    const control = new FormControl(formState);
    (this.activityFilterForm.get(controlArrayName) as FormArray).push(control);
  }

  private setActivityFilterData() {
    this.activityFilterService.getActivityFilterViewModel(this.filterId).subscribe(res => {
      this.activityFilterViewModel = res;
      this.filterId = this.activityFilterViewModel.filterId;
      this.populateFilterFormData();
      // this.userDataOptions = res.data;
      // this.userRoleOptions = res.users;
      // this.activityTypes = res.activities;
    });
  }

  onSolutionTreeClick(tools: ActivitySelectionItem) {
    //console.log('tools:', tools);
    const dialogModel: DialogModel = DialogModel.create(
      'Tool Selector',
      tools.editor.editor,
      {selectedToolIds: tools.editor.selectedValues, allToolsSelected: this.activityFilterViewModel.tools.editor.allRecords},
      '800px',
      '800px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        //console.log('[solution tree] ', res.data.input);
        let allToolsSelected = res.data.input.allToolsSelected;
        let tools = this.activityFilterViewModel.tools;
        tools.editor.selectedValues = res.data.input.selectedToolIds;
        tools.editor.allRecords = allToolsSelected;
        if(allToolsSelected) {
          tools.editor.displayText = `All ${tools.key}`;
        } else {
          this.activityFilterViewModel.tools.editor.displayText = tools.editor.selectedValues.length == 0 ? `Select ${tools.key}` : `${tools.editor.selectedValues.length} ${tools.key}`;
        }
        this.onApply(false);
      }
    });
  }

  saveFilter(title: string = null) {
    if (!this.isFilterValid() || !title) {
      return;
    }
    let fieldValues = {};
    fieldValues['IsDraft'] = false;
    let tmpViewModel: any = {...this.activityFilterViewModel};
    tmpViewModel.filterId = '';
    tmpViewModel.isDraft = false;
    tmpViewModel.title = title;
    fieldValues['ActivityFilterViewModel'] = tmpViewModel;
    this.saveFilterToApi(fieldValues);
  }

  saveFilterToApi(fieldValues: any = {}, dispatchFilter: boolean = true) {
    if(dispatchFilter) {
      this.isDrityFilter = true;
      fieldValues['AlwaysReturnActivityFilterModel'] = true;
    }
    this.activityFilterService.saveActivityFilter(fieldValues).pipe(takeUntil(this.unSubscribe$)).subscribe(filter => {
      //console.log('saved filterId:', filter);
      if(filter && dispatchFilter) {
        //this.isDrityFilter = false;
        this.dispatchFilter(filter);
      } else {
        this.isDrityFilter = false;
      }
    });
  }

  private populateFilterFormData() {
    if (!this.activityFilterViewModel) {
      return;
    }
    if (this.activityFilterViewModel.activities && this.activityFilterViewModel.activities.length > 0) {
      this.activityFilterViewModel.activities.forEach(activity => {
        const control = new FormControl(activity.isChecked);
        (this.activityFilterForm.controls.activityTypesArray as FormArray).push(control);
      });
    }
    if (this.activityFilterViewModel.users && this.activityFilterViewModel.users.length > 0) {
      this.activityFilterViewModel.users.forEach(user => {
        const control = new FormControl(user.isChecked);
        (this.activityFilterForm.controls.usersRolesArray as FormArray).push(control);
      });
    }
    if (this.activityFilterViewModel.data && this.activityFilterViewModel.data.length > 0) {
      this.activityFilterViewModel.data.forEach(d => {
        const control = new FormControl(d.isChecked);
        (this.activityFilterForm.controls.userDataArray as FormArray).push(control);
      });
    }
  }

  private isFilterValid() {
    if (!this.activityFilterViewModel.title) {
      this.snackBarService.showError('Title cannot be empty!');
      return false;
    }
    return true;
  }

  private createNewFilter() {
    this.activityFilterService.createActivityFilter().pipe(takeUntil(this.unSubscribe$)).subscribe(filter => {
      //console.log('add new filter:', filter);
      if (filter) {
        this.onAddNewFilter$.emit();
        this.filterId = filter.id;
        this.setActivityFilterData();
      }
    });
  }

  private fetchActivityFiltersByType(filterType: ActivityFilterType) {
    //console.log(filterType);
    this.activityFilterService.getActivityFiltersByType(filterType.type).pipe(takeUntil(this.unSubscribe$)).subscribe(filters => {
      //console.log('filters:', filters);
      this.activityFilters = filters;
      this.collaborationStore.dispatch(new SetCurrentTypeOfSavedFilter(filterType));
    });
  }

  getSelectedUsers(selectedEmails) {
    const selectedUsers = {};
    selectedEmails.forEach(email => {
      selectedUsers[email] = {
        permission: ChatPermissions[0],
        isChecked: true,
        isDirty: false,
        disableSelection: false,
        disableRoleSelection: true
      };
    });
    return selectedUsers;
  }

  private onUserSelector(data: ActivitySelectionItem, index: number) {
    const permissions = ChatPermissions;
    const defaultPermission = permissions[0];
    const currentUserAsSelectedUser = this.getSelectedUsers(this.activityFilterViewModel.users[index].editor.selectedValues);
    const key = 'AllContactList';
    const dialogRef = this.dialog.open(ShareItemsComponent, {
      minWidth: '800px',
      maxWidth: '800px',
      data: {
        showTaskManagerRole: true,
        queryKey: key,
        itemId: '',
        selectIndex: 0,
        allUserSelected: data.editor.allRecords? true: false,
        metaData: {
          'permissions': permissions,
          'selectedUsers': currentUserAsSelectedUser,
          'defaultPermission': defaultPermission
        }
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: any) => {
      //console.log(result);
      if (result && result.selection) {
        //console.log('[contact] ', result);
        this.selectedUsers = result.selection.map(user => user.user.email);
        let allItemsSelected = this.selectedUsers.length === this.totalUserCount;
        if(!allItemsSelected) {
          this.uncheckUsersAllRecords();
        }
        //console.log('[selected user] ', this.selectedUsers);
        let userEditor = this.activityFilterViewModel.users[index];
        userEditor.editor.selectedValues = this.selectedUsers;
        //todo: need to fix allrecords correctly
        userEditor.editor.allRecords = allItemsSelected;
        if(allItemsSelected) {
          userEditor.editor.displayText = `All ${userEditor.key}`;
        } else {
          userEditor.editor.displayText = this.selectedUsers.length == 0 ? `Select ${userEditor.key}` : `${this.selectedUsers.length} ${userEditor.key}`;
        }
        if(this.isAllChecked(this.activityFilterViewModel.users)) {
          let indexOfAll = this.activityFilterViewModel.users.findIndex(activity => activity.key === 'All');
          let formArray= this.activityFilterForm.get('usersRolesArray') as FormArray;
          formArray.at(indexOfAll).setValue(true);
          this.activityFilterViewModel.users[indexOfAll].isChecked = true;
        }
        this.onApply(false);
      }
    });
  }

  private uncheckUsersAllRecords() {
    let indexOfAll = this.activityFilterViewModel.users.findIndex(activity => activity.key === 'All');
    let formArray= this.activityFilterForm.get('usersRolesArray') as FormArray;
    this.activityFilterViewModel.users[indexOfAll].isChecked = false;
    formArray.at(indexOfAll).setValue(false);
  }

  private uncheckDataAllRecords() {
    let indexOfAll = this.activityFilterViewModel.data.findIndex(activity => activity.key === 'All');
    let formArray= this.activityFilterForm.get('userDataArray') as FormArray;
    this.activityFilterViewModel.data[indexOfAll].isChecked = false;
    formArray.at(indexOfAll).setValue(false);
  }

  private isAllChecked(items: ActivitySelectionItem[], checkItemLabel: boolean = true) {
    let indexOfAllCheckbox = items.findIndex(activity => activity.key === 'All');
    let totalItemsCount = items.length;
    for(let i=0;i<totalItemsCount; i++) {
      if(i!==indexOfAllCheckbox) {
        if(items[i].isChecked === false) {
          return false;
        } else if(checkItemLabel) {
          if(items[i].editor.allRecords ==false) {
            return false;
          }
        }
      }
    }
    return true;
  }
}
